import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import {
  ProjectPicker,
  ProjectPickerSchema,
} from './ProjectPicker';

export const ProjectPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ProjectPicker',
    component: ProjectPicker,
    schema: ProjectPickerSchema as CustomFieldExtensionSchema,
  }),
);